/*
 *  -----------------------------------------------------------------------
 *    <copyright file="two-options-dialog/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */
import React from 'react';
import ActionDialog from '../../../core/action-dialog';
import { TwoOptionsDialogProps } from './two-options-dialog.interface';

const TwoOptionsDialog = ({
    title,
    submitText,
    handleClose,
    handleSubmit,
    extraBntText,
    extraBntOnClick,
    className,
    children,
}: TwoOptionsDialogProps) => (
    <ActionDialog
        title={title}
        onClose={handleClose}
        submitText={submitText}
        onSubmit={handleSubmit}
        extraBnt={!!(extraBntText && extraBntOnClick)}
        extraBntText={extraBntText}
        extraBntOnClick={extraBntOnClick}
        className={className}
    >
        {children}
    </ActionDialog>
);

export default TwoOptionsDialog;
